if (!customElements.get('acs-video-row')) {
  customElements.define(
    'acs-video-row',
    class AcsVideoRow extends HTMLElement {
      constructor() {
        super();
        this.handleVideoOpen = this.handleVideoOpen.bind(this);
        this.updateCarouselControls = this.updateCarouselControls.bind(this);
        this.handleFocusOut = this.handleFocusOut.bind(this);
        this.handleModalClosed = this.handleModalClosed.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        this.startCarousel = this.startCarousel.bind(this);
        this.stopCarousel = this.stopCarousel.bind(this);
        this.advanceCarousel = this.advanceCarousel.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.handleVideoOpen);
        this.addEventListener('pointerenter', this.stopCarousel);
        this.addEventListener('pointerleave', this.startCarousel);
        this.addEventListener('focusin', this.stopCarousel);
        this.addEventListener('focusout', this.handleFocusOut);
        document.body.addEventListener('modalClosed', this.handleModalClosed);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);
        window.addEventListener('resize', this.updateCarouselControls);
        this.track = this.querySelector('[data-video-track]');
        this.previousButton = this.querySelector('[data-video-previous]');
        this.nextButton = this.querySelector('[data-video-next]');

        if (this.track) {
          this.track.addEventListener('scroll', this.updateCarouselControls);
          this.updateCarouselControls();
          this.startCarousel();
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleVideoOpen);
        this.removeEventListener('pointerenter', this.stopCarousel);
        this.removeEventListener('pointerleave', this.startCarousel);
        this.removeEventListener('focusin', this.stopCarousel);
        this.removeEventListener('focusout', this.handleFocusOut);
        document.body.removeEventListener('modalClosed', this.handleModalClosed);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        window.removeEventListener('resize', this.updateCarouselControls);
        this.stopCarousel();
        if (this.track) this.track.removeEventListener('scroll', this.updateCarouselControls);
      }

      handleVideoOpen(event) {
        const previousButton = event.target.closest('[data-video-previous]');
        const nextButton = event.target.closest('[data-video-next]');
        if ((previousButton || nextButton) && this.track) {
          const direction = previousButton ? -1 : 1;
          const firstItem = this.track.querySelector('.acs-video-row-item');
          if (!firstItem) return;
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
          const step = firstItem.getBoundingClientRect().width + gap;
          if (direction > 0 && this.track.scrollLeft >= maxScroll - 1) {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });
          } else if (direction < 0 && this.track.scrollLeft <= 1) {
            this.track.scrollTo({ left: maxScroll, behavior: 'smooth' });
          } else {
            this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
          }
          this.startCarousel();
          return;
        }

        const opener = event.target.closest('[data-video-modal]');
        if (!opener || !this.contains(opener)) return;

        const modal = document.querySelector(opener.dataset.videoModal);
        if (!modal) return;

        event.preventDefault();
        this.modalIsOpen = true;
        this.stopCarousel();
        modal.show(opener.querySelector('button'));

        const video = modal.querySelector('video');
        if (!video) return;

        video.onended = () => modal.hide();
        if (video.readyState > 0) video.currentTime = 0;
        video.play().catch(() => {});
      }

      handleFocusOut(event) {
        if (!this.contains(event.relatedTarget)) this.startCarousel();
      }

      handleModalClosed() {
        this.modalIsOpen = false;
        this.startCarousel();
      }

      handleVisibilityChange() {
        if (document.hidden) {
          this.stopCarousel();
        } else {
          this.startCarousel();
        }
      }

      startCarousel() {
        this.stopCarousel();
        if (document.hidden || !this.track || this.modalIsOpen || this.matches(':hover') || this.contains(document.activeElement)) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (this.track.scrollWidth <= this.track.clientWidth + 1) return;
        this.carouselTimer = window.setInterval(this.advanceCarousel, 5000);
      }

      stopCarousel() {
        if (this.carouselTimer) window.clearInterval(this.carouselTimer);
        this.carouselTimer = null;
      }

      advanceCarousel() {
        if (!this.track || this.modalIsOpen) return;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        if (this.track.scrollLeft >= maxScroll - 1) {
          this.track.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }
        const firstItem = this.track.querySelector('.acs-video-row-item');
        if (!firstItem) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({ left: firstItem.getBoundingClientRect().width + gap, behavior: 'smooth' });
      }

      updateCarouselControls() {
        if (!this.track) return;
        const canScroll = this.track.scrollWidth > this.track.clientWidth + 1;
        if (this.previousButton) this.previousButton.disabled = !canScroll;
        if (this.nextButton) this.nextButton.disabled = !canScroll;
      }
    }
  );
}
